import React from 'react';

import Icon from '../../../components/AppIcon';

const QuickActionsPanel = ({ 
  onScheduleReports, 
  onCustomizeWidgets, 
  onDrillDownAnalytics, 
  onManageEmailTemplates, 
  onTestSMTP,
  onViewAuditLogs,
  onViewSecurityAlerts
}) => {
  const quickActions = [
    {
      id: 'dealership-management',
      title: 'Autohäuser verwalten',
      description: 'CRUD-Operationen für Partnerschaften',
      icon: 'Building2',
      color: 'primary',
      route: '/dealership-management'
    },
    {
      id: 'application-processing',
      title: 'Anträge bearbeiten',
      description: 'Status-Updates und Bulk-Aktionen',
      icon: 'FileText',
      color: 'success',
      route: '/application-processing'
    },
    {
      title: 'Audit-Protokolle',
      description: 'Sicherheits- und Compliance-Protokolle anzeigen',
      icon: 'FileText',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      action: onViewAuditLogs
    },
    {
      title: 'Sicherheitswarnungen',
      description: 'Aktive Sicherheitswarnungen überprüfen',
      icon: 'ShieldAlert',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      action: onViewSecurityAlerts
    }
  ];

  const colorClasses = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    success: 'bg-success/10 text-success hover:bg-success/20',
    warning: 'bg-warning/10 text-warning hover:bg-warning/20'
  };

  return (
    <div className="bg-card rounded-lg shadow-card border border-border p-6">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
        Schnellzugriff
      </h2>
      <div className="space-y-3">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className={`w-full flex items-center gap-4 p-4 rounded-lg transition-smooth ${colorClasses?.[action?.color]}`}
          >
            <div className="flex-shrink-0">
              <Icon name={action?.icon} size={24} />
            </div>
            <div className="flex-1 text-left">
              <h3 className="font-medium text-foreground">{action?.title}</h3>
              <p className="text-sm text-muted-foreground">{action?.description}</p>
            </div>
            <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;